<template>
    <div class="tc-select-case-card">
        <img class="tc-select-case-card-img"
             :src="getImage(item.image)">
        <div class="tc-select-case-card-body">
            <div class="tc-select-case-card-body-label">
                {{item.name}}
            </div>
            <div class="tc-select-case-card-body-list">
                <div class="tc-select-case-card-body-list-item">
                    {{item.props[0]}}
                </div>
                <div class="tc-select-case-card-body-list-item">
                    {{item.props[1]}}
                </div>
                <div class="tc-select-case-card-body-list-item">
                    {{item.props[2]}}
                </div>
                <div class="tc-select-case-card-body-list-item">
                    {{item.props[3]}}
                </div>
            </div>
            <div class="tc-select-case-card-body-footer">
                <div class="tc-select-case-card-body-footer-price">
                    От {{storeItemsFromApi.getApiItemByXmlId(item.xmlId)?.price ?? 0}} {{currencySymbol}}
                </div>
                <div class="tc-case-card-btn-container">
                    <OrangeButtonOfLawlessness :text="'Перейти к построению'"
                                               @click="selectCase()"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OrangeButtonOfLawlessness from '@/UI/CommonComponents/OrangeButtonOfLawlessness.vue';
import { useStoreUI } from '@/Store/storeUI';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { casesLib } from '@/Constants/casesLib';
import { toolChestDefaultConfig } from '@/Constants/toolChestDefaultConfig';
import { getImage } from '@/libs/getImage';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { useStoreItemsFromApi } from '@/Store/storeItemsFromApi';
import { useStoreMeta } from '@/Store/storeMeta';


export default {
    name: 'SelectCaseCard',
    components: {
        OrangeButtonOfLawlessness,
    },
    props: [
        'item',
    ],
    setup() {
        const storeUI = useStoreUI();
        const storeMeta = useStoreMeta();
        const storeCaseConfiguration = useStoreCaseConfiguration();
        const storeProjectStructure = useStoreProjectStructure();
        const storeItemsFromApi = useStoreItemsFromApi();
        return {
            storeUI,
            storeCaseConfiguration,
            storeProjectStructure,
            storeItemsFromApi,
            storeMeta,
        };
    },
    computed:{
      currencySymbol(){
        return this.storeMeta.currency;
      },
    },
    methods: {
        getImage,
        selectCase() {
            if (!this.storeMeta.user)  {
              this.storeProjectStructure.clear();
            }
            this.storeUI.setIsSelectCase(false);
            this.storeProjectStructure.addNewCase(this.item.key);
            this.$router.push({
                path: '/configurator',
            });
        },
    },
};
</script>

<style scoped lang="scss">
.tc-select-case-card {
    display: flex;
    width: 100%;
    height: 300px;
    flex-direction: row;
    gap: 20px;
    padding: 20px;
    cursor: pointer;
    box-sizing: border-box;
    background-color: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

.tc-select-case-card-img {
    height: 100%;
    width: 210px;
    object-fit: cover;
    box-sizing: border-box;
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    background-color: #ffffff;
}

.tc-select-case-card-body {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: space-between;
    color: #333333;
    box-sizing: border-box;
}

.tc-select-case-card-body-label {
    font-size: 16px;
    font-weight: 600;
}

.tc-select-case-card-body-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
    height: max-content;
    width: 100%;
}

.tc-select-case-card-body-list-item {
    font-size: 14px;
}

.tc-select-case-card-body-footer {
    display: flex;
    height: max-content;
    width: 100%;
    box-sizing: border-box;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
}

.tc-select-case-card-body-footer-price {
    font-size: 14px;
    font-weight: 600;
}

.tc-case-card-btn-container {
    box-sizing: border-box;
    height: max-content;
    width: 246px;
}

</style>
